<template>
  <div id="container">
    <div class="box-content-title">
    <el-row>
      <el-col :span="12">
        <div class="title-font-style">
          <span>团队业绩管理</span>
        </div>
      </el-col>
      <el-col :span="12" style="text-align:right">
        <el-radio-group v-model="dataName.column" @change="changeRadio" class="dropdownright">
          <el-radio-button type="text" label="month">月度</el-radio-button>
          <el-radio-button type="text" label="year">年度</el-radio-button>
        </el-radio-group>
        <el-date-picker

          @change="changeTime"
          v-model="dataName.value"
          :type="dataName.column"
          :value-format="dataName.column==='year'?'yyyy':'yyyy-MM'"
        ></el-date-picker>
      </el-col>
    </el-row>
    </div>
    <el-form class="search-style">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item>
            <el-select v-model="queryParams.column" @change="onChangeColumn">
              <el-option
                v-for="(item,
                      index) in teamPerformanceManage"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-input v-model="queryParams.value" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="box-table" :style="{height: ($store.state.Sell.heightTitle-8)+'px'}">
      <el-table
        border
        ref="tableRef"
        :data="list"
        :max-height="$store.state.Sell.heightTitle-8"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="staffName" label="销售员" width="120px" fixed>
          <template slot-scope="scope">
            <span class="approval" @click="toStaffName(scope.row)">{{ scope.row.staffName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orgName" label="所属部门"></el-table-column>
        <el-table-column label="流水" header-align="center">
          <el-table-column prop label="当期销售流水" width="110">
            <template slot-scope="scope">
              {{ scope.row.contractRate|priceFilter}}
            </template>
          </el-table-column>
          <el-table-column prop="afterSalesFlow" label="售后流水">
            <template slot-scope="scope">{{ scope.row.afterSalesFlow|priceFilter}}</template>
          </el-table-column>
          <el-table-column prop="logisticsExpenses" label="物流费用">
            <template slot-scope="scope">{{ scope.row.logisticsExpenses|priceFilter}}</template>
          </el-table-column>
          <el-table-column prop="fundOccupation" label="资金占用">
            <template slot-scope="scope">{{ scope.row.fundOccupation|priceFilter}}</template>
          </el-table-column>
          <el-table-column prop="passContractFlow" label="往期流水更正" width="110">
            <template slot-scope="scope">{{ scope.row.passContractFlow|priceFilter}}</template>
          </el-table-column>
          <el-table-column prop="flow" label="流水值">
            <template slot-scope="scope">{{ scope.row.flow|priceFilter}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="提成" header-align="center">
          <el-table-column prop="badDebt" label="坏账">
            <template slot-scope="scope">{{ scope.row.badDebt|priceFilter}}</template>
          </el-table-column>
          <el-table-column prop="afterCommission" label="售后提成">
            <template slot-scope="scope">{{ scope.row.afterCommission|priceFilter}}</template>
          </el-table-column>
          <el-table-column prop="logisticsExpenses" label="物流费用">
            <template slot-scope="scope">{{ scope.row.logisticsExpenses|priceFilter}}</template>
          </el-table-column>
          <el-table-column prop="achievements" label="绩效">
            <template slot-scope="scope">{{ scope.row.achievements|priceFilter}}</template>
          </el-table-column>
          <el-table-column prop="commission" label="流水提成">
            <template slot-scope="scope">{{ scope.row.commission|priceFilter}}</template>
          </el-table-column>
          <el-table-column prop="commissionRate" label="提成比例">
            <template slot-scope="scope">{{ scope.row.commissionRate|perCentFilter}}</template>
          </el-table-column>
          <el-table-column label="最终提成">
            <template slot-scope="scope">{{ scope.row.endCommission|perCentFilter}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="cusName" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button @click="onPen(scope.row)" type="text">奖惩</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
    <el-dialog title="绩效管理" :visible.sync="isShow" width="30%">
      <el-form :model="params" label-width="80px" label-position="right">
        <el-row>
          <el-col :span="11">
            <el-form-item label="选择：">
              <el-select v-model="params.operationType">
                <el-option label="奖励金额" value="奖励金额"></el-option>
                <el-option label="扣除金额" value="扣除金额"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="金额：">
              <el-input
                oninput="value=value.replace(/[^0-9.]/g,'')"
                v-model="params.operationAmount"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="原因：">
              <el-input v-model="params.mark" type="textarea" placeholder="原因不能为空！" :rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit">提 交</el-button>
        <el-button @click="isShow = false">取 消</el-button>
      </div>
    </el-dialog>
    <open-or-close ref="OpenOrClose" @onUpdataState="onUpdataState" title="提示" :content="content"></open-or-close>
  </div>
</template>
<script>
import { teamPerformanceManage } from './util/data'
import OpenOrClose from '@/components/OpenOrClose/index'
import { performanceManageTeam, orderAchievement } from '@/api/sell/sellManage'
import pagination from '@/components/pagination'
export default {
  components: {
    pagination,
    'open-or-close': OpenOrClose
  },
  data () {
    return {
      dataName: {
        column: 'month',
        value: ''
      },
      queryParams: {
        column: '',
        value: ''
      },
      params: {}, // 所选员工//弹窗对象
      isShow: false,
      content: '',
      teamPerformanceManage, // 搜索下拉数据
      list: [], // 列表数据
      loadingTable: false, // 列表loading
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    onUpdataState () {
      this.params.staffId = this.params.ownId
      orderAchievement(this.params).then((res) => {
        if (res.data.code === 200) {
          // this.$message.success('处理成功')
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
        this.isShow = false
      })
    },
    onSubmit () {
      if (!this.params.operationType) {
        this.$message.error('请选择奖罚')
        return
      }
      if (!this.params.operationAmount) {
        this.$message.error('请填写金额')
        return
      }
      if (!this.params.mark) {
        this.$message.error('请填写原因')
        return
      }
      this.content = `确认后将${this.params.operationType}${this.params.operationAmount}元给${this.params.staffName}。`
      this.$refs.OpenOrClose.onInitial()
    },
    onPen (row) {
      this.params = row
      this.isShow = true
    },
    toStaffName (row) {
      this.$router.push({
        name: 'sellCommissionStatistics',
        query: { id: row.ownId }
      })
    },
    changeTime () {
      this.onReset()
    },
    changeRadio () {
      this.dataName.value = ''
    },
    onSearch () {
      // 搜索
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    onReset () {
      this.queryParams = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    getList () {
      this.loadingTable = true
      var obj = {
        criteriaVoList: [],
        queryPageName: ''
      }
      if (this.dataName.value) {
        obj.criteriaVoList.push(this.dataName)
      }
      if (this.queryParams.value) {
        obj.criteriaVoList.push(this.queryParams)
      }
      performanceManageTeam(1, this.currentPage, this.pageSize, obj).then(
        (res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records
            this.total = res.data.obj.total
          } else {
            this.$message.error(res.data.msg)
          }
        }
      )
    },
    onChangeColumn (val) {
      // 改变下拉框
      this.queryParams = {}
      this.queryParams.column = val
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
.dropdownright {
  margin-right: 15px;
  line-height: 28px;
  vertical-align: middle;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #276cff;
  border-color: #276cff;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner:hover {
  color: #fff;
}
/deep/.el-radio-button__inner:hover {
  color: #276cff;
}
</style>
